export default function createHtml(src) {
  return { __html: src }
}
